getSessionStorageKey = function(t) { 
  for (let e = 0; e < sessionStorage.length; e++) { 
    let l = sessionStorage.key(e); 
    if (l.includes(t)) 
      return l 
  } 
  return null 
};

$.fn.excludeClass = function($class) {
    var that = this;
    var element = that[0];
    var cls = element.className;
    var parts = cls.split(' ');

    for (var i = 0; i < parts.length; i++) {

        var part = parts[i];
        if (part != $class) {

            element.className = element.className.replace(part, '');

        }

    }
    return that;
}

// $("body").on("click",".login-btn",function(){
//   $('.login-dialog').show();
//   $('body').addClass("dialog-open");
// })

document.addEventListener("vsk:product:changed", function(e){
  var productID = e.detail.productID;
  var variantDetails = JSON.parse(sessionStorage.getItem(getSessionStorageKey(productID)));
  var cardTarget = e.target;
  var cardContentEl = $(cardTarget).find(".card__content"); 

  console.log(variantDetails);

  if($(".quickadd-open").length) {
    $(".quick-add-modal__toggle").trigger("click");
  }  

  // Discount percentage update
  var price = variantDetails.variants.nodes[0].price.amount;
  var compareAtPrice = variantDetails.variants.nodes[0].compareAtPrice.amount;

  $(cardTarget).find(".promo-badge").remove();

  if(price != compareAtPrice) {
    var salePercentage = Math.floor(100 - (price/compareAtPrice) * 100);
    $('<div class="promo-badge">'+ salePercentage +'% Off Sale</div>').appendTo(cardContentEl);
  } 
  // END - Discount percentage update

  // Product Tag Display Update
  var prodTags = variantDetails.tags;

  // -- hide/unhide add to bag btn
  if(!prodTags.includes("PWP") && !prodTags.includes("DROPLIVE") && !prodTags.includes("CSOON") && !prodTags.includes("WHS")) {
    $(cardTarget).find(".quick-add, .quick-add-box").removeAttr("style");
  } else {
    $(cardTarget).find(".quick-add, .quick-add-box").hide();
  }

  // -- login btn
  if(prodTags.includes("WHS")) {
    $('<div class="quick-add quick-login"><a class="login-btn">Sign In</a></div>').insertBefore($(cardTarget).find(".quick-add"));
  } else {
    $(cardTarget).find(".quick-login").remove();
  }

  // -- top left label
  var prodTagTopEl = $(cardTarget).find(".prodtag-top");
  var prodTagTopHtml = $("<div class='prodtag-top'></div>");

  if($(prodTagTopEl).length == 0) {
    $(cardTarget).find(".card__media").append(prodTagTopHtml);
  } 

  $(prodTagTopEl).excludeClass("prodtag-top").html("");

  if (prodTags.includes("VARONL") || prodTags.includes("Exclusive")) {
    $(prodTagTopEl).addClass("exclusive").html('<img src="//levisplus.myshopify.com/cdn/shop/files/online-exclusive-tag.webp?v=1697533051&amp;width=80" alt="" srcset="//levisplus.myshopify.com/cdn/shop/files/online-exclusive-tag.webp?v=1697533051&amp;width=80 80w" width="80" height="80">').show();
  } else if (prodTags.includes("VARPLANT")) {
    $(prodTagTopEl).addClass("plant").html('<span>PLANT-BASED 501®</span>').show();
  } else {
    $(prodTagTopEl).hide();
  }

  // -- bottom right label
  var prodTagBottomEl = $(cardTarget).find(".prodtag-bottom");
  var prodTagBottomHtml = $("<div class='prodtag-bottom'></div>");

  if($(prodTagBottomEl).length == 0) {
    $(cardTarget).find(".card__media").append(prodTagBottomHtml);
  } 

  $(prodTagBottomEl).excludeClass("prodtag-bottom").html("");

  if(prodTags.includes("C-MIJ")) {
    $(prodTagBottomEl).addClass("mij").html('<img src="//levisplus.myshopify.com/cdn/shop/files/MIJ_Tag.jpg?v=1697531552&amp;width=100" alt="" srcset="//levisplus.myshopify.com/cdn/shop/files/MIJ_Tag.jpg?v=1697531552&amp;width=100 100w" width="100" height="42">').show();
  } else if(prodTags.includes("5-1-Logo")) {
    $(prodTagBottomEl).addClass("logo501").html('<img src="//levisplus.myshopify.com/cdn/shop/files/501_150.webp?v=1693808250&amp;width=100" alt="" srcset="//levisplus.myshopify.com/cdn/shop/files/501_150.webp?v=1693808250&amp;width=100 100w" width="100" height="129">').show();
  } else if(prodTags.includes("Hanni-L") || prodTags.includes("Haerin-L") || prodTags.includes("Minji-L") || prodTags.includes("Danielle-L") || prodTags.includes("Hyein-L")) {
    $(prodTagBottomEl).addClass("newjeans").html('NewJeans’ Pick').show();
  } else {
    $(prodTagBottomEl).hide();    
  }

  // -- collection label
  var prodTagCollectionEl = $(cardTarget).find(".prodtag-collection");
  var prodTagCollectionHtml = $("<span class='prodtag-collection'></span>");

  if($(prodTagCollectionEl).length == 0) {
    $(cardTarget).find(".card__information").prepend(prodTagCollectionHtml);
  }

  if(prodTags.includes("C-MIJ")) {
    $(prodTagCollectionEl).text("Made in Japan").show();
  } else if(prodTags.includes("M-COOL") || prodTags.includes("W-COOL")) {
    $(prodTagCollectionEl).text("+Levi’s® Cool").show();
  } else {
    $(prodTagCollectionEl).hide();
  }

  // -- stock info label
  var stockInfoEl = $(cardTarget).find(".stock-info");
  var stockInfoHtml = $("<span class='stock-info'></span>");

  if($(stockInfoEl).length == 0) {
    $(cardTarget).find(".card__content ").append(stockInfoHtml);
  }

  if(prodTags.includes("CSOON") || prodTags.includes("VARCSOON")) {
    $(stockInfoEl).text("Coming Soon").show();
  } else if(prodTags.includes("WHS")) {
    $(stockInfoEl).text("Warehouse Sale").show();
  } else {
    $(stockInfoEl).hide();
  }

  
  // END - Product Tag Display Update
});